globalThis.appCustomerSpace = globalThis.appCustomerSpace || {};
appCustomerSpace.Modals = appCustomerSpace.Modals || {};
appCustomerSpace.Modals.Settings = appCustomerSpace.Modals.Settings || {};

appCustomerSpace.Modals.Settings.ContactsAfterImport = (function(superClass) {

  utils.extend(ContactsAfterImport, superClass);

  function ContactsAfterImport() {
    return ContactsAfterImport.__super__.constructor.apply(this, arguments);
  }

  $.extend(ContactsAfterImport.prototype, {
    init: function() {
      var modal = this;

      modal._initEvents();
      var controller = this;

      App.cable.subscriptions.create({
        channel: "CustomerSpace::Crm::ImportContactsChannel",
        list_uniq_key: modal.$html.find(".modal-content").attr('data-list-uniq-key')
      }, {
        received: function(data) {
          switch (data.action) {
            case 'update_list':
              console.log(data.html)
              controller.$html.find('.modal-content').replaceWith($(data.html));
              break;
          }
        }
      });
      return ContactsAfterImport.__super__.init.apply(this, arguments);
    },
    _initEvents: function() {
      var modal = this;

      modal.$html.on('click', '.new-import', function(){
        modal.close()
      })
    },
  });

  return ContactsAfterImport;

})(appCustomerSpace.Modal);
